module.exports = __webpack_public_path__ + "static/media/biometria_ah30.1324e1f8.mp4";